<div class="header-row">
  <div class="header">Lista institucija</div>

  <div class="filters-grid">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Pretraga po nazivu vendora</mat-label>
      <input matInput [formControl]="vendorFilter" placeholder="Unesi vendor...">
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Pretraga po nazivu laboratorije</mat-label>
      <input matInput [formControl]="filterNameControl" placeholder="Unesi laboratoriju...">
    </mat-form-field>
    
    <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Pretraga po nazivu ustanove</mat-label>
      <input matInput [formControl]="filterParentControl" placeholder="Unesi ustanovu...">
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Tip ustanove</mat-label>
      <mat-select [formControl]="filterTypeControl">
        <mat-option value="">Svi tipovi</mat-option>
        @for (type of typeInstitution; track type.key) {
          <mat-option [value]="type.key">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="table-container">
  <div class="mat-elevation-z2 table-relative-wrapper">
    
    @if (isLoading && institutions.data.length === 0) {
      <div class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    }

    @if (!isLoading && institutions.data.length === 0) {
      <div class="no-data-container">
       Nema podataka
      </div>
    }

    <div [hidden]="institutions.data.length === 0">
      <table mat-table [dataSource]="institutions" matSort (matSortChange)="handleSortChange($event)" class="mat-elevation-z0">
        
        <ng-container matColumnDef="vendor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor</th>
          <td mat-cell *matCellDef="let institution">{{ institution.vendor | dashIfEmpty }}</td>
        </ng-container>

        <ng-container matColumnDef="institutionCode">
          <th mat-header-cell *matHeaderCellDef>Šifra laboratorije</th>
          <td mat-cell *matCellDef="let institution">{{ institution.institutionCode | dashIfEmpty }}</td>
        </ng-container>

        <ng-container matColumnDef="institutionName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Naziv laboratorije</th>
          <td mat-cell *matCellDef="let institution">{{ institution.institutionName | dashIfEmpty }}</td>
        </ng-container>

        <ng-container matColumnDef="parentInstitution">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Naziv ustanove</th>
          <td mat-cell *matCellDef="let institution">{{ institution.parentInstitution | dashIfEmpty }}</td>
        </ng-container>

        <ng-container matColumnDef="institutionType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tip ustanove</th>
          <td mat-cell *matCellDef="let institution">{{ institution.institutionType | dashIfEmpty }}</td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Lokacija</th>
          <td mat-cell *matCellDef="let institution">{{ institution.location | dashIfEmpty }}</td>
        </ng-container>

        <ng-container matColumnDef="lastTransactionTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum sinhronizacije</th>
          <td mat-cell *matCellDef="let institution">
            {{ institution.lastTransactionTime | date:'MMM dd yyyy' | dashIfEmpty }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row-color"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        (page)="handlePageEvent($event)"
        [length]="length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        aria-label="Odaberi stranicu"
        [showFirstLastButtons]="true"
        [hidePageSize]="true">
      </mat-paginator>
    </div>

  </div>
</div>